import { Button, H3, Modal, P, PropsModal } from '@vgrubs/components';

export const DeleteModifierModal = ({
  deleteModal,
  closeModal,
  handleDeleteItem,
}: PropsModal & {
  deleteModal: boolean;
  handleDeleteItem: () => void;
}) => {
  return (
    <Modal isOpen={deleteModal} closeModal={closeModal} logo={false}>
      <H3 $mb="24">
        <span>Are you sure</span>
      </H3>
      <P $mb="40">Are you sure you want to delete this modifier?</P>

      <Button $selected $w="100%" $mb="8" onClick={handleDeleteItem}>
        Confirm
      </Button>

      <Button $selected $w="100%" $gray onClick={() => closeModal?.()}>
        Cancel
      </Button>
    </Modal>
  );
};
